import { mchenryServiceCoreUrl } from "../../main";

export type AdminState = {
  adminModalUser: any;
  isAdminModalLoading: boolean;
  adminUsers: any[];
};

export type AdminActions = {
  getAuthHeaders: () => Record<string, string>;
  setAdminModalUser: (user: any) => void;
  setIsAdminModalLoading: (loading: boolean) => void;
  deleteUser: (userId: string) => Promise<boolean>;
  resetUserPassword: (userId: string) => Promise<boolean>;
  updateUser: (user: any) => Promise<boolean>;
  createUser: (user: any) => Promise<boolean>;
  setAdminUsers: (users: any[]) => void;
  loadAdminUsers: () => Promise<void>;
  blockedEmails: string[];
  setBlockedEmails: (emails: string[]) => void;
};

export const createAdminSlice = (set, get): AdminState & AdminActions => ({
  blockedEmails: [],
  setBlockedEmails: (emails) => {
    set({ blockedEmails: emails });
  },
  isAdminModalLoading: false,
  setIsAdminModalLoading: (loading) => {
    set({ isAdminModalLoading: loading });
  },
  getAuthHeaders: () => {
    const config = get().config;
    const tokenKey = config.authenticationService.localStorageTokenKey;
    const token = localStorage.getItem(tokenKey);
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  },
  adminModalUser: null,
  setAdminModalUser: (user) => {
    set({ adminModalUser: user });
  },
  deleteUser: async (userId) => {
    // set({ isAuthLoading: true });
    const url = `${mchenryServiceCoreUrl}/Users/DeleteUser?userId=${userId}`;
    await fetch(url, { headers: get().getAuthHeaders() });
    get().loadAdminUsers();

    // return data.IsLocal;
    return true;
  },
  resetUserPassword: async (userId) => {
    // set({ isAuthLoading: true });
    const { prodAppUrl } = get().config.authenticationService;
    const url = `${mchenryServiceCoreUrl}/Users/ResetUserPassword?userId=${userId}&appUrl=${prodAppUrl}`;
    await fetch(url, { headers: get().getAuthHeaders() });
    return true;
  },
  updateUser: async (user) => {
    const tokenUrl = `${mchenryServiceCoreUrl}/Users/UpdateUser`;
    const originalUser = get().adminModalUser;
    const combinedUser = { ...originalUser, ...user };

    await fetch(tokenUrl, {
      headers: get().getAuthHeaders(),
      method: "POST",
      body: JSON.stringify(combinedUser),
    });
    get().loadAdminUsers();
    return true;
  },
  createUser: async (user) => {
    const url = mchenryServiceCoreUrl;
    const tokenUrl = `${url}/Users/CreateUser?appUrl=${
      get().config.authenticationService.prodAppUrl
    }`;
    await fetch(tokenUrl, {
      headers: get().getAuthHeaders(),
      body: JSON.stringify(user),
      method: "POST",
    });
    get().loadAdminUsers();
    return true;
  },
  loadAdminUsers: async () => {
    const config = get().config;
    const tokenKey = config.authenticationService.localStorageTokenKey;
    const token = localStorage.getItem(tokenKey);
    if (!token) {
      get().setAdminUsers([]);
    }
    const queryString = config.authenticationService.allowedUserRoles
      .map((role) => `allowedRoles=${role}`)
      .join("&");

    const url = `${mchenryServiceCoreUrl}/Users/GetUsers?${queryString}`;
    const res = await fetch(url, { headers: get().getAuthHeaders() });
    if (!res.ok) {
      get().setAdminUsers([]);
    }
    get().setAdminUsers(await res.json());
  },
  adminUsers: [],
  setAdminUsers: (users) => {
    set({ adminUsers: users });
  },
});
